var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24512 0.0908201L3.8916 4.09863L5.74902 0.0908203L7.15527 0.0908203L4.24902 5.90918L3.41113 5.90918L0.844727 0.09082L2.24512 0.0908201Z",
    fill: "#0D4248"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrowDown);
export default __webpack_public_path__ + "static/media/greenArrowDown.be7b01936ae1567b069b9b6a2a122f00.svg";
export { ForwardRef as ReactComponent };